// extracted by mini-css-extract-plugin
export default {"tooltip":"lS-z","arrow":"mS-z"};